import React from 'react';
import queryString from 'query-string';
import { Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'five';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();
    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });


    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value,
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className="login-five-container text-align-center" ref={this.ref}>
          <div className="login-five-body">
            <div className="login-five-header" style={{ marginBottom: '40px' }}>
              <img src={logo} alt="logo" className="logo-five rounded mx-auto d-block" />
            </div>
            <Form onSubmit={event => this.onSubmit(event)}>
              <input
                className="user-input-five"
                disabled={this.state.onLogin}
                ref={(ref) => this.usernameInput = ref}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
                placeholder="Usuário"
              />
              <input
                className="user-input-five"
                required={true}
                disabled={this.state.onLogin}
                ref={(ref) => this.passwordInput = ref}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
                placeholder="Senha"
              />
              {!this.state.onLogin ?
                <div className="row five-btns-row">
                  <div className="col-xs-12 col-md-12 col-lg-12">
                    <div>
                      <button
                        block={!this.parameters.failureRedirect}
                        tabIndex={1}
                        className="enter-five"
                        type="submit"
                        name="submit"
                        disabled={!this.props.turnstileSuccess}
                      >
                        <i class="fa fa-sign-out"></i>  {this.props.translate("ButtonEnter")}
                      </button>
                    </div>
                  </div>
                </div>
                :
                <Progress animated color="danger" value={100} />
              }
              <div className="messages-container">
                <Alert color="danger" id="error-message" isOpen={this.state.error.open} toggle={() => this.setState({ error: { open: false } })}>
                  {this.state.error.message}
                </Alert>
              </div>
            </Form>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { style: { marginTop: '2rem' } });
